"use client";

import { useState } from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import { useLocale, useTranslations } from "next-intl";
import { eventName, totalPieces } from "@/lib/avatar/events";
import { phaseLabel } from "./eventTime";

// La fenêtre de l'événement n'est téléchargée que si le membre l'ouvre.
const EventModal = dynamic(() => import("./EventModal"), { ssr: false });

// En tête des quêtes du jour pendant un événement de puzzles : un bandeau aux couleurs de
// l'événement, qui dit ce que les coffres contiennent en plus et où en est le membre. C'est
// ici qu'on comprend que chaque coffre donne une pièce. Un clic ouvre les puzzles.
export default function EventQuestsHeader({ state, className = "" }) {
    const t = useTranslations();
    const locale = useLocale();
    const [open, setOpen] = useState(false);
    const event = state?.event;
    if (!event || event.phase !== "open") return null;

    const theme = event.theme || {};
    const total = totalPieces(event);
    const count = state.mine?.total || 0;
    const [label, values] = phaseLabel(event, locale);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                className={`group relative flex w-full items-center gap-3 overflow-hidden rounded-xl p-3 text-left text-white transition-transform duration-200 hover:scale-[1.01] ${className}`}
                style={{ background: `linear-gradient(120deg, ${theme.dark || "#2A1F4D"}, ${theme.dark || "#2A1F4D"} 45%, ${theme.color || "#613BDB"})` }}
            >
                {theme.chests?.common && <Image src={theme.chests.common} alt="" width={52} height={45} unoptimized className="h-[45px] w-[52px] shrink-0 drop-shadow-lg transition-transform duration-300 group-hover:-rotate-6" />}
                <span className="min-w-0 flex-1">
                    <span className="flex flex-wrap items-baseline gap-x-2">
                        <span className="text-sm font-bold">{eventName(event, locale)}</span>
                        <span className="text-xs text-white/70">{t(label, values)}</span>
                    </span>
                    <span className="block text-xs text-white/85">{t(total > 0 && count >= total ? "avatar_event_quests_done" : "avatar_event_quests_hint")}</span>
                    <span className="mt-1.5 flex items-center gap-2">
                        <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/20">
                            <span className="block h-full rounded-full bg-white transition-[width] duration-500 ease-out" style={{ width: `${total ? Math.round((count / total) * 100) : 0}%` }} />
                        </span>
                        <span className="shrink-0 text-[11px] font-medium tabular-nums text-white/85">{t("avatar_event_quests_progress", { count, total })}</span>
                    </span>
                </span>
                <span className="shrink-0 rounded-lg bg-white/15 px-2.5 py-1.5 text-xs font-semibold transition-colors group-hover:bg-white/25">{t("avatar_event_quests_cta")}</span>
            </button>
            {open && <EventModal isOpen onClose={() => setOpen(false)} />}
        </>
    );
}
